import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import PropTypes from "prop-types";
import {CircleAnimation} from "./components/loading";
import { 
	message
} from "antd";

const apiUrl = process.env.REACT_APP_API_URL;

const Login = ({ setUser, setToken }) => {
	const { isAuthenticated, isLoading, getAccessTokenSilently, loginWithRedirect } = useAuth0();
	const [isFetchingUser, setIsFetchingUser] = useState(true);

	useEffect(() => {
		const fetchUserData = async () => {
			if (isAuthenticated) {
				const token = await getAccessTokenSilently();
				localStorage.setItem("authToken", token);
				setToken(token);
				try {
					const response = await axios.post(`${apiUrl}/auth_user`, {
						token,
						action: "login"
					});
					setUser(response.data);
					setIsFetchingUser(false);
				} catch (error) {
					message.error(error.response.data);
					
					handleLogout();
				}
			} else {
				loginWithRedirect({
					authorizationParams: {
						scope: "openid profile email"
					}
				});
			}
		};

		if (!isLoading) {
			fetchUserData();
		}
	}, [isAuthenticated, getAccessTokenSilently, setUser, setToken, isLoading, loginWithRedirect]);

	const handleLogout = () => {
		localStorage.removeItem("authToken");
		localStorage.removeItem("companies");
		setUser(null);
		setToken("");
		/* loginWithRedirect({
			returnTo: window.location.origin
		}); */
	};

	if (isLoading || isFetchingUser) {
		return (
			<div className="login-container">
				<CircleAnimation />
			</div>
		);
	}

	// Este componente no debería llegar a renderizar nada más que la animación si no está autenticado.
	return null;
};

Login.propTypes = {
	setUser: PropTypes.func,
	setToken: PropTypes.func,
};

export default Login;
